export enum HelperSourceEnum {
  NA = 'NotAvailable',

  // --- input
  SpecialRemark = 'SpecialRemark',
  SpecialNote = 'SpecialNote', // 西醫特記打字查詢(E0190)
  CC = 'CC', // cheif complaint
  PE = 'PE', // physical examination
  Diag = 'Diag', // diagnosis
  ChiLook = 'ChiLook',
  ChiAsk = 'ChiAsk',
  ChiPulse = 'ChiPulse',
  ChiPulseLeft = 'ChiPulseLeft',
  ChiPulseRight = 'ChiPulseRight',
  ChiBianZheng = 'ChiBianZheng',
  ChiTreatRule = 'ChiTreatRule',
  ChiTreatEffect = 'ChiTreatEffect',
  ChiDoctorOrder = 'ChiDoctorOrder',
  // --- grid
  Order = 'Order',
  ChiOrder = 'ChiOrder',
  DentalOrder = 'DentalOrder',
  DentalExamfee = 'DentalExamfee',

  // --- order grid dropdown
  Freq = 'Freq', // order freq
  Day ='Day',
  Dose ='Dose',
  Way = 'Way', // order way
  CMD = 'CMD',
  Remark = 'Remark',
  SpRule = 'SpRule',
  ChiPart = 'ChiPart',//中醫部位
  ChiAcupoint = 'ChiAcupoint',//中醫穴位
  ChiAcupointChart = 'ChiAcupointChart',//中醫穴位圖
  Dispensing = 'Dispensing',
  ChiProcess = 'ChiProcess', // ChiProcess
  ToothPos = 'ToothPos', // 牙位
  ToothFace = 'ToothFace', // 牙面
  PCS = 'PCS', // 牙科PCS

  WayPart = 'WayPart', // order way - part

  // history list
  HistList = 'HistList', // 歷史紀錄清單
}
